module.exports = __webpack_public_path__ + "img/logo-small.e25c4efb.png";